import {
  storyblokEditable,
  StoryblokRichText,
  StoryblokComponent,
  BlockTypes,
} from "@storyblok/react";
import DOMPurify from "dompurify";
import "./blog-post.css";
import { RelatedPosts } from "./RelatedPosts";
import { ShareLinks } from "./ShareLinks";

const SUMMARY_ALLOWED_TAGS = ["p", "br", "b", "i", "em", "strong", "a"];
const SUMMARY_ALLOWED_ATTR = ["href", "target", "rel"];

const formatDate = (isoString) => {
  const date = new Date(isoString);
  if (Number.isNaN(date.getTime())) return isoString;
  return date.toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
};

const richTextResolvers = {
  [BlockTypes.COMPONENT]: (node) => (
    <StoryblokComponent blok={node.attrs.body[0]} key={node.attrs.body[0]._uid} />
  ),
  // The HTML->richtext converter emits `content: []` on void-element nodes
  // (hr/br/img); the default renderer passes that through as `children`,
  // which React rejects on a void element. Render these without children —
  // via the renderer's `render`, which gives each element a unique React key.
  [BlockTypes.HR]: (_node, { render }) => render("hr"),
  [BlockTypes.BR]: (_node, { render }) => render("br"),
  [BlockTypes.IMAGE]: (node, { render }) =>
    render("img", { src: node.attrs?.src, alt: node.attrs?.alt || "" }),
};

const BlogPost = ({ blok }) => {
  return (
    <div {...storyblokEditable(blok)} className="post">
      <div className="container herosub post-hero">
        <h1>{blok.title}</h1>
        {blok.subtitle ? <h2>{blok.subtitle}</h2> : null}
        {blok.published_at ? (
          <time dateTime={blok.published_at}>{formatDate(blok.published_at)}</time>
        ) : null}
      </div>
      <div className="text-left blog-content">
        {blok.summary ? (
          <div
            className="blog-summary"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(blok.summary, {
                ALLOWED_TAGS: SUMMARY_ALLOWED_TAGS,
                ALLOWED_ATTR: SUMMARY_ALLOWED_ATTR,
              }),
            }}
          />
        ) : null}
        {blok.featured_image?.filename && !blok.hide_featured_image_on_post ? (
          <div className="featured-image">
            <img
              src={blok.featured_image.filename}
              alt={blok.featured_image.alt}
            />
          </div>
        ) : null}
        <ShareLinks title={blok.title} />
        <div className="blog-content-main">
          <StoryblokRichText doc={blok.maincontent} resolvers={richTextResolvers} />
        </div>
        <ShareLinks title={blok.title} />
      </div>
      <RelatedPosts post={blok} />
    </div>
  );
};

export default BlogPost;
